module.exports = __webpack_public_path__ + "static/media/Roboto-Black.72f6fd21.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Black.woff2
// module id = 537
// module chunks = 0